import { ScheduleOrg } from '@wetags/schedule';
import { SchedulerV3 } from '@frontend/api-schedule-v3';

export const useScheduleActivityAccess = () => {
  const [isScheduleActivityWetagEnabled, isLoadingWetag] = ScheduleOrg.useWetag('schedule-activity');
  const [isAvailabilityFinderEnabled, isLoadingAvailabilityFinderTag] = ScheduleOrg.useWetag(
    'availability-visualization-v3'
  );

  const { isScheduleV3FlagEnabled, isLoading: isLoadingV3Flag } =
    SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const isLoading = isLoadingWetag || isLoadingV3Flag;
  const isEnabled = isScheduleActivityWetagEnabled && isScheduleV3FlagEnabled;

  return {
    isScheduleActivityEnabled: !isLoading && isEnabled,
    isLoading,
    isAvailabilityFinderEnabled,
    isLoadingAvailabilityFinderTag,
  };
};
